import React                           from 'react';
import { arrayRailsBottom as tooltip } from 'pu-data/Tooltips';
import TextComponent                   from './TextComponent';

const ArrayRailsBottom = (props) => {
  const name = 'rails_bottom';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  return (
    <TextComponent
      label="Bottom rail"
      name={name}
      value={props.parameters[name] || ''}
      onChange={props.onChange || onChange}
      tooltip={tooltip}
      groupName={props.groupName} />
  );
};

ArrayRailsBottom.defaultProps = {};

export default ArrayRailsBottom;
